"use strict";

var _slicedToArray = require("/opt/build/repo/app/node_modules/@babel/runtime/helpers/slicedToArray.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiltersSelected = void 0;

var react_1 = __importDefault(require("react"));

var SelectedFilters_1 = __importDefault(require("@appbaseio/reactivesearch/lib/components/basic/SelectedFilters"));

var components_1 = require("../../components");

var hooks_1 = require("../../hooks");

var FiltersSelected = function FiltersSelected(props) {
  var _a;

  var filtersHook = (0, hooks_1.useFilters)();
  var RenderComponent = (_a = props.render) !== null && _a !== void 0 ? _a : components_1.ExampleFiltersSelected;
  return react_1.default.createElement(SelectedFilters_1.default, {
    render: function render(_ref) {
      var selectedValues = _ref.selectedValues,
          setValue = _ref.setValue;
      var selectedFilters = Object.entries(selectedValues).filter(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            item = _ref3[1];

        var _a, _b;

        return (item === null || item === void 0 ? void 0 : item.URLParams) && (item === null || item === void 0 ? void 0 : item.showFilter) && (!!((_a = item === null || item === void 0 ? void 0 : item.value) === null || _a === void 0 ? void 0 : _a.length) || !!((_b = item === null || item === void 0 ? void 0 : item.value) === null || _b === void 0 ? void 0 : _b.label));
      }).map(function (_ref4) {
        var _ref5 = _slicedToArray(_ref4, 2),
            key = _ref5[0],
            item = _ref5[1];

        return {
          key: key,
          label: item.label,
          value: item.value
        };
      });

      var handleRemove = function handleRemove(selectedFilterKey) {
        var selectedFilterValues = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

        var _a;

        var filter = (_a = filtersHook.filters) === null || _a === void 0 ? void 0 : _a.find(function (filter) {
          return filter.handle === selectedFilterKey;
        });

        if (!filter) {
          return;
        }

        if (filter.displayType === "slider") {
          var event = new CustomEvent("@usereactify/search:filter:".concat(filter.handle, ":update"), {
            detail: {
              handle: filter.handle,
              value: []
            }
          });
          window.dispatchEvent(event);
          return;
        }

        if (selectedFilterValues.length === 0) {
          setValue(selectedFilterKey, null);
          return;
        }

        if (selectedFilterValues.length > 0) {
          if (filter.displayType === "single") {
            setValue(selectedFilterKey, null);
          }

          if (filter.displayType === "multi") {
            if (filter.displayView === "range") {
              var values = selectedValues[selectedFilterKey].value.filter(function (value) {
                return !selectedFilterValues.includes(value.label);
              }).map(function (value) {
                return value.label;
              });

              var _event = new CustomEvent("@usereactify/search:filter:".concat(filter.handle, ":update"), {
                detail: {
                  handle: filter.handle,
                  value: values
                }
              });

              window.dispatchEvent(_event);
            }

            if (filter.displayView !== "range") {
              var _values = selectedValues[selectedFilterKey].value.filter(function (value) {
                return !selectedFilterValues.includes(value);
              });

              setValue(selectedFilterKey, _values);
            }
          }
        }
      };

      if (!selectedFilters.length) {
        return null;
      }

      return react_1.default.createElement(RenderComponent, {
        selectedFilters: selectedFilters,
        handleRemove: handleRemove
      });
    }
  });
};

exports.FiltersSelected = FiltersSelected;